import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetActivities(parentType, parentId) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/activity/`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestObjectActivity(parentType, parentId, page = 1, limit = 25) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/activity/${parentType}/${parentId}`,
        params: { page, limit },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUserActivity(userId, page = 1, limit = 25) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/activity/user/${userId}`,
        params: { page, limit },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestAccountActivity(accountId, page = 1, limit = 25) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/activity/account/${accountId}`,
        params: { page, limit },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestClientActivity(clientId, page = 1, limit = 25) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/activity/client/${clientId}`,
        params: { page, limit },
        withCredentials: true,
        crossorigin: true,
    });
}